export const DEFAULT_SCROLL_OFFSET = 56
export const SCROLL_POSITION_INACCURACY_MARGIN = 0.5

export const calculateVerticalDistanceFromWindow = (element: HTMLElement) => {
  return (
    element.getBoundingClientRect().top -
    DEFAULT_SCROLL_OFFSET -
    SCROLL_POSITION_INACCURACY_MARGIN
  )
}
